var siteURL = window.location.href;
// API url
var apiUrl = '';
var isProduction = false;
if (siteURL.indexOf('dev.') >= 0 || siteURL.indexOf('test.') >= 0 || siteURL.indexOf('.loc') >= 0 || siteURL.indexOf('.dev') >= 0 || siteURL.indexOf('127.0.0.1') >= 0) /// Dev env
{
	apiUrl = 'https://dev.api.alternativemedia.com.au/';
} else if (siteURL.indexOf('staging.') !== -1) {
	apiUrl = '//staging.api.alternativemedia.com.au/';
} else /// Production env
{
	apiUrl = '//api.alternativemedia.com.au/';
	isProduction = true;
}

$(function() {
 
	// randomized name
	disableAutoComplete();

	// use apikey
	var apikey = 'mvv9e4q4dkxk22tbw1e0';

 
	var val_url = $("#custom__field-val").val();
 
	const EXTERNAL_QUOTES_PAGE_URL = val_url;

	// landing page and formpage
	var form_page = window.location.href;
	form_page = (form_page.indexOf('?') > -1 ? form_page.split('?').slice(0, -1).join('') : form_page);

	// var get_path = getCookie('dimension3'); not needed

	var landing_page_cookie = checkCookie('landing_page') ? getCookie('landing_page') : ( localStorage.landing_page !== undefined ? localStorage.landing_page : window.location.href ),
			landing_page_url = (landing_page_cookie.indexOf('?') > -1 ? landing_page_cookie.split('?')[0] : landing_page_cookie),
			landing_page_arr = landing_page_cookie.split(landing_page_url),
			landing_page = landing_page_url + (landing_page_arr[1].indexOf('http://') > -1 ? landing_page_arr[1].split('http://')[0] : (landing_page_arr[1].indexOf('https://') > -1 ? landing_page_arr[1].split('https://')[0] : landing_page_arr[1]));


	// not needed
		
	// var new_val__URL = window.location.protocol + "//" + window.location.host + get_path + window.location.search
 
	// $("#landing_page").val(new_val__URL);		

	// set cookie for utms
	// var utms = checkCookie('utms') ? getCookie('utms') : '';

	// if (window.location.search.length > 0) {
	// 	utms = window.location.search.indexOf('utm_medium') !== -1 || window.location.search.indexOf('utm_source') !== -1 ? '' : utms;
	// 	var parts = window.location.search.substr(1).split("&");
	// 	for (var i = 0; i < parts.length; i++) {
	// 		var temp = parts[i].split("=");
	// 		if (decodeURIComponent(temp[0]).indexOf('utm_') > -1) {
	// 			utms += '&' + decodeURIComponent(temp[0]) + '=' + decodeURIComponent(temp[1]);
	// 		}
	// 	}
	// }

	// var utm_source = source_check('Source', utms);
	// var utm_medium = source_check('Medium', utms);

	// if (utms != '') {

	// 	utms = parse_query_string(utms);

	// 	if(typeof utms.utm_source == 'undefined')
	// 		utms.utm_source = utm_source;

	// 	if(typeof utms.utm_medium == 'undefined')
	// 		utms.utm_medium = utm_medium;

	// 	setCookie('utms', $.param(utms), 7);
	// 	localStorage.utms = $.param(utms);

	// } else {

	// 	setCookie('utms', 'utm_source=' + utm_source + '&utm_medium=' + utm_medium, 7);
	// 	localStorage.utms = 'utm_source=' + utm_source + '&utm_medium=' + utm_medium;
	// }

	$('#leadformSearch, .formnya').each(function(){

	    var form = $(this),
	        heroAction = form.attr('action'),
	        heroMethod = form.attr('method');

	    var param = '';

	    // append hidden fields based on utms
	    if(typeof heroMethod !== 'undefined')
	        appendToForms(form);

	    // for other hidden fields 
	    form.find("input[type='hidden']").each(function(){
	        var name = $(this).attr("name");
	        var val = $(this).val();
	        param += name+"="+val+"&";
	    });
	    
	    if( typeof heroMethod !== 'undefined' && heroMethod.toLowerCase() == 'post' ) {
	        // append the form values in the form action
	        form.attr('action', heroAction + '?' + param);
	    }


	});

	function generateSlider(id, val, min, max, step, money) {
		var elem = $(id);
		var id_arr = id.split('-');
		id_arr.splice(0, 1);
		var format = (money ? true : false);
		var hiddenfield = $('#amount-' + id_arr.join('-'));
		elem.slider({
			range: "min",
			value: val,
			min: min,
			max: max,
			step: step,
			slide: function(event, ui) {
				hiddenfield.val(ui.value);
				var sliderVal = (format ? '$' + addCommas(ui.value) : ui.value);
				elem.find('.shadow').text(sliderVal);
				if (ui.value === max) {
					elem.find('.shadow').text(sliderVal + '+');
				}
			}
		});
		var sliderVal = (format ? '$' + addCommas(elem.slider("value")) : elem.slider("value"));
		elem.children('.ui-slider-handle').append('<span class="shadow">' + sliderVal + '</span>')
		elem.children('.ui-slider-handle').attr('tabindex', '9');
		hiddenfield.val(elem.slider("value"));
	}

	$('.go-slider').each(function(index, val) {
		var id = '#' + $(this).attr('id');
		var sliderConfig = $(this).attr('data-slider-config').split(' ');
		var val = parseInt(sliderConfig[0]);
		var min = parseInt(sliderConfig[1]);
		var max = parseInt(sliderConfig[2]);
		var step = parseInt(sliderConfig[3]);
		var format = sliderConfig[4];
		generateSlider(id, val, min, max, step, format);
	});

	function generateSlider2(element) {
		$(element).slider({
			range: "min",
			min: parseInt($(element).attr('data-min')),
			max: parseInt($(element).attr('data-max')),
			value: parseInt($(element).attr('data-default')),
			step: parseInt($(element).attr('data-step')),
			create: function() {
				var handlervalue = ($(element).attr('data-format') === 'money') ? '$' + addCommas($(this).slider("value")) : $(this).slider("value");
				$(this).children('.lic-slide-handle').html('<span class="lic-slider-tip">' + handlervalue + '</span>')
			},
			slide: function(event, ui) {
				var handlervalue = ($(element).attr('data-format') === 'money') ? '$' + addCommas(ui.value) : ui.value;
				if (ui.value === parseInt($(element).attr('data-max'))) {
					$(this).children('.lic-slide-handle').html('<span class="lic-slider-tip">' + handlervalue + '+</span>');
				} else {
					$(this).children('.lic-slide-handle').html('<span class="lic-slider-tip">' + handlervalue + '</span>');
				}
				$(element).parents('.lic-slide-wrapper').children('input[type="hidden"]').val(ui.value)
			}
		});
	}

	// logo sliders
	$('.lenders-slider').slick({
		dots: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		speed: 1000,
		slidesToShow: 8,
		slidesToScroll: 1,
		responsive: [{
				breakpoint: 1024,
				settings: {
					slidesToShow: 6
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 4
				}
			}
		]
	});

	$('.lic-slider').each(function() {
		generateSlider2('#' + $(this).attr('id'));
	});

	$('.lic-slide-wrapper select').change(function(e) {
		$(this).siblings('input[type="hidden"]').val($(this).val())
	});

	// xsell
	if ($('body').hasClass('page-template-tpl-xsell') || $('body').hasClass('page-template-tpl-affiliate')) {
		// if ($('body').hasClass('page-template-tpl-xsell') || $('body').hasClass('page-template-tpl-affiliate') || $('body').hasClass('page-template-tpl-ref-add')) {


		apikey = 'r6f2g1p83lka09msqwiv';

		// time allowed
		var min_callback_time = 10,
			max_callback_time = 17;

		for (var x = min_callback_time; x <= (max_callback_time - hours_difference); x++) {
			time_allowed.push(x + ':00:00');
		}

		function format_time(ct, element) {
			var the_date = element.val().split(' ')[0],
				the_time = element.val().split(' ')[1].split(':')[0] + ':00:00';

			if ($.inArray(the_time, time_allowed) == -1)
				the_time = time_allowed[0];

			element.val(the_date + ' ' + the_time)
		}

		// calback date picker
		$('#callbackTime').datetimepicker({
			minDate: 0,
			format: 'Y-m-d H:i:s',
			allowTimes: time_allowed,
			closeOnDateSelect: true,
			onSelectDate: function(ct, element) {
				format_time(ct, element);
			},
			onSelectTime: function(ct, element) {
				format_time(ct, element);
			}
		});

	}

	// affiliate page
	if ($('body').hasClass('page-template-tpl-affiliate')) {
		apikey = 'SYtUlYrFOv3g5Zw2jvPd';
	}

	// referral-add page
	if ($('body').hasClass('page-template-tpl-ref-add')) {
		apikey = 'mvv9e4q4dkxk22tbw1e0';
	}

	$('#resend-sms-form').submit(function(e){
		e.preventDefault();

		if ($(this).hasClass('inprogress')) {
			return false;
		}

		const source = 'LIC';

		$(this).addClass('inprogress');

		const originalText = $(this).find('#resend-sms-form-button').text();

		$(this).find('#resend-sms-form-button').text('Sending...');

		$('#sms-verify-form').prop('disabled', true);

		const el = $(this);

		$('.sms-error-tooltip').removeClass('visible-error').removeClass('visible-success');

		$.ajax({
			url : apiUrl + 'sms/generate-code',
			type : 'POST',
			data: { phone_number : $('#resend-number').val(), source : source },
			success : function(response) {
				el.find('#resend-sms-form-button').text(originalText);
				el.removeClass('inprogress');

				if (response.data.success == false) {
					el.find('.sms-error-tooltip').removeClass('visible-success').addClass('visible-error').text('Please enter valid phone number');
				} else {
					el.find('.sms-error-tooltip').removeClass('visible-error').addClass('visible-success').text('Verification SMS Sent');;
					$('#phone').val($('#resend-number').val());
					$('#resend-number').val('');
				}

				$('#sms-verify-form').prop('disabled', false);
			},
			error : function(e) {
				el.find('#resend-sms-form-button').text(originalText);
				el.removeClass('inprogress');
				$('#sms-verify-form').prop('disabled', false);

				el.find('.sms-error-tooltip').addClass('visible-error');
			}
		})
	});

	var onelength = function(elem) {

		var input_index = parseInt(elem.attr('id').split('inputsms')[1]) + 1,
			input_next = $('#inputsms' + input_index),
			input_val = elem.val();

		if (input_val.length > 1)
			elem.val(input_val.slice(0, 1))

		if (input_val.length >= 1 && input_index <= 4)
			input_next.focus();

	}

	$('.oneleng').keydown(function(event) {
		onelength($(this));

		var input_index = parseInt($(this).attr('id').split('inputsms')[1]) - 1,
			key = event.keyCode || event.charCode;

	    if( (key == 8 || key == 46) && input_index !== 0) {

	    	if ($(this).val() == '') {
	    		$('#inputsms' + input_index).focus();
	    	} else {
	    		$(this).val('');
	    	}
	    }

	    if( key === 13 ) {
	    	$(this).parents('form').find('button').click();
	    }
	});

	$('.oneleng').keyup(function(){
		onelength($(this))
	});

	$('.oneleng').focus(function() {
		$(this).val('')
	});

	// edm emailaddress var
	var edm_email = '';
	$('.formSubmit').click(function(e) {

		var $queryString = parse_query_string(window.location.search.substring(1));

		// const sourceCondition = $queryString.utm_source === 'google' && $queryString.utm_medium === 'display';
		const sourceCondition = false;

		var formID = '#' + $(this).parents('.lpForm').attr('id');

		// apiUrl = 'http://api.am.local:8080/';

		var source = 'LIC';

		e.preventDefault();

		if (validateFormFields(formID)) {
			// if verification needed show modal else call function
			var verificationNeeded = $('#sms_verification').val() === 'SMS_ON' ? true : false;

			if (verificationNeeded || sourceCondition) {

				const originalText = $(this).text();

				$(this).addClass('inprogress');
				$(this).text('Gathering your quotes');
				const el = $(this);
				$.ajax({
					url : apiUrl + 'sms/generate-code',
					type: 'POST',
					data: { phone_number : $('#phone').val(), source : source },
					success : function(response) {
						el.removeClass('inprogress');


						$('body').addClass('sms-modal-active');
						$('#inputsms1').focus();

						// $('#resend-number').val($('#phone').val());

						$('#sms-verify-form').unbind('submit').submit(function(e){
							e.preventDefault();

							if ($(this).hasClass('inprogress')) {
								return false;
							}

							$(this).addClass('inprogress');

							const formEl = $(this);

							$('.sms-error-tooltip').removeClass('visible-error').removeClass('visible-success');

							var code = "";
							$('.oneleng').each(function(){
								code += $(this).val()
							});

							const text = $(this).find('#verify-sms').text();

							$(this).find('#verify-sms').text('Verifying...');

							if (isBypass(code)) {
								$('#sms-error').text("");
								createLead(el);
							} else {
								$.ajax({
									url : apiUrl + 'sms/verify-code',
									type : 'POST',
									data : { phone_number : $('#phone').val(), code :  code},
									success : function(response) {

										if (response.data.success == true) {
											// $('#sms-error').text("");
											formEl.find('.sms-error-tooltip').removeClass('visible-error');
											createLead(el);
										} else {
											formEl.find('.sms-error-tooltip').addClass('visible-error');
											// $('#sms-error').text(response.data.message);
										}
										formEl.find('#verify-sms').text(text);
										formEl.removeClass('inprogress');
									},
								})
							}
						});
						// el.text()
					},
					error : function(response) {
						console.log('error?');
						el.removeClass('inprogress');
						el.text(originalText);
					}
				});
			} else {
				return createLead($(this));
			}
		}

	});

	function isBypass(code){
		if (code == '9876' && (isProduction === false) ) {
			return true;
		}
		return false;
	}

	// if ($('body').hasClass('page-template-tpl-cb')) {

	// 		if ($('.wpcf7-form').length > 0) {

	// 			$('.fullname').blur(function() {
	// 			    $('#cf7name').val($(this).val());
	// 			});
	// 			$('.phone').blur(function() {
	// 			    $('#cf7phone').val($(this).val());
	// 			});

	// 			$('#bestTime').blur(function() {
	// 			    $('#cf7time').val($(this).val());
	// 			});

	// 			$('#submit-cb').click(function(event){
	// 				if (validateFormFields('#get-a-cb')) {
	// 					$('.wpcf7-form').submit();
						
	// 			    }
	// 			});
	// 			document.addEventListener( 'wpcf7mailsent', function( event ) {
	// 			  $('.cb-alert').addClass('alert-visible');
	// 			}, false );
	// 		}

	// 	}


	function createLead(el)
	{
		var old_btn_text = el.text();
		// e.preventDefault();
		var formID = '#' + el.parents('.lpForm').attr('id');
		disableAutoComplete($(formID), true);

		if (el.hasClass('inprogress')) {
			return false;
		}

		$('body').removeClass('sms-modal-active');
		el.addClass('inprogress');
		if ($('body').hasClass('page-template-tpl-cb')) {
			el.text('Booking your call');
		}else{
			el.text('Gathering your quotes');
		}
		
		if ($('.dollarInput').length > 0) {
			$('.dollarInput').each(function() {
				var amount = $(this).val().indexOf('$') > -1 ? $(this).val().slice(1) : $(this).val();
				amount = amount.replace(/,/g, "");
				if (parseInt(amount) < 1 || amount === null || amount === undefined || amount === '') {
					amount = '';
					$(this).val(amount)
				}
			})
		}
		// if (validateFormFields(formID)) {

			console.log('true')

			el.addClass('inprogress');

			if ($('body').hasClass('page-template-tpl-advisor-revamp')) {

				var new_btn_text = 'Gathering your quotes...';

				el.text(new_btn_text);
			}

			if (formID === '#get-a-cb') {
				// cb submit
				if (checkcallhours()) {
					submitCB();
				}

			} else {

				if ($('input[data-format="address"]').length > 0) {
					$('input[data-format="address"]').each(function() {
						var address_val = $('input[data-format="address"]').val().trim().split(','),
							state_val = address_val[1].trim().toLowerCase(),
							suburb_val = address_val[0].trim().toLowerCase(),
							postcode_val = address_val[2].trim();

						$(this).siblings('.hidden_state').val(state_val),
							$(this).siblings('.hidden_suburb').val(suburb_val),
							$(this).siblings('.hidden_postcode').val(postcode_val);
					});
				}

				// lead submit
				if ($('.dollarInput').length > 0) {
					$('.dollarInput').each(function() {
						var amount = $(this).val().indexOf('$') > -1 ? $(this).val().slice(1) : $(this).val();
						amount = amount.replace(/,/g, "");
						$(this).val(amount);
					});
				}

				if (el.parents('.loader-btn').find('.loading-btn').length > 0) {
					el.hide();
					el.siblings('.loading-btn').show();
				}

				if (el.parents('.lpForm').find('.loading-icon').length > 0) {
					el.parents('.lpForm').find('.loading-icon').show();
				}

				if ($('#loading-logo').length > 0) {
					el.hide();
					$('#loading-logo').show();
				}

				// var leadDataUtm = '';
				// if(checkCookie('utms') || localStorage.utms !== undefined) {
				// 	var utm_cookieArr = checkCookie('utms') ? getCookie('utms') : ( localStorage.utms !== undefined ? localStorage.utms : '' );
				// 		utm_cookieArr = utm_cookieArr.split("&");
				// 	for (var i = 0; i < utm_cookieArr.length; i++) {
				// 		var temp = utm_cookieArr[i].split("=");
				// 		if(decodeURIComponent(temp[0]).indexOf('utm_') > -1) {
				// 			leadDataUtm += '"' + decodeURIComponent(temp[0]) + '":"' + decodeURIComponent(temp[1]) + '",';
				// 		}
				// 	}
				// }

				if(el.parents('.lpForm').find('textarea').length > 0) {
					el.parents('.lpForm').find('textarea').each(function(){
						var textContent = $(this).val().replace(/\n/g,' ');
						$(this).val(textContent);
					});
				}

				if (el.parents('.lpForm').find('textarea').length > 0) {
					el.parents('.lpForm').find('textarea').each(function() {
						var textContent = $(this).val().replace(/\n/g, ' ');
						$(this).val(textContent);
					});
				}


				// update this use array instead
				var leadDataArray = el.parents('.lpForm').serializeArray();
				var leadData = "{";
				var viewedQuotesParamFound = false;

				$.each(leadDataArray, function(i, leadDataArray) {
					if (leadDataArray.name.toLowerCase() !== 'viewed_quotes_c') {
						leadData += '"' + leadDataArray.name + '":"' + leadDataArray.value + '",';
					} else {
						leadData += '"viewed_quotes": "yes",';
						viewedQuotesParamFound = true;
					}
				});

				if (!viewedQuotesParamFound) {
					leadData += '"viewed_quotes": "no",';
				}

				// if(leadData.indexOf('utm') < 0 ) {
				// 	if (leadDataUtm != '' && !$('body').hasClass('page-template-tpl-affiliate')) {
				// 		leadData += leadDataUtm;
				// 	}
				// }
				leadData = leadData.slice(0, -1);

				if ($('input[name="name"]').length > 0) {
					var fullname = $.trim($('input[name="name"]').val());
					fullname = fullname.split(' ');
					var first_name = '';
					$('#last_name').val(fullname.slice(-1));
					for (var i = 0; i < fullname.length - 1; i++) {
						if (i > 0) {
							first_name += ' ';
						}
						first_name += fullname[i];
					}
					leadData += ',"first_name' + '":"' + first_name + '","last_name' + '":"' + fullname.slice(-1) + '"';
				}

				leadData += ',"landing_page":"' + landing_page + '","form_page":"' + form_page + '","apikey":"' + apikey + '"';


				if(clientId != undefined && clientId.length > 0) {
					leadData += ',"ga_client_id":"' + clientId + '"';
				}

				// additional data if calculator modal exists
				if($('#used_cover_calculator').length > 0) {
					leadData += ',"used_cover_calculator":"' + $('#used_cover_calculator').val() + '"';
				}

				leadData += '}';

				console.log('leadDataString: ', leadData);

				setCookie('leadData', leadData, 1);
				localStorage.leadData = leadData;

				leadData = $.parseJSON(leadData);
				if(typeof leadData.smoker !== 'undefined')
					leadData.smoker = parseInt(leadData.smoker);
				// console.log(leadData);

				if(typeof leadData.uuid !== 'undefined')
					delete leadData.uuid;

				var leadDataUtm = checkCookie('utms') ? JSON.parse(getCookie('utms')) : {};

				leadData = {...leadData, ...leadDataUtm};

				// log submissions
				submitLogger(JSON.stringify(leadData), 'lic-advisor');

				$.ajax({
					url: apiUrl + 'lead/create',
					dataType: 'json',
					type: 'POST',
					data: leadData,
					success: function(data) {
						console.log(data);

						if (data.data.lead_uuid.length > 1) {
							setCookie('lead_uuid', data.data.lead_uuid, 1);

							var cw_id = data.data.response && data.data.response.length !== undefined ? data.data.response.split(' ') : '';
							cw_id = cw_id !== '' ? cw_id[cw_id.length - 1] : '';

							if ($('body').hasClass('page-template-tpl-xsell')) {

								if(data.error == null || data.error !== 'null') {
									$('#successModal').find('.am_uuid').text(data.data.lead_uuid);
									$('#successModal').modal({
										show: true
									});
								} else {
									$('#failedModal').find('.am_uuid').text(data.data.lead_uuid);
									var modal_error_message = typeof data.data.response.length !== undefined && data.data.response.toLowerCase().indexOf('error') !== -1 ? data.data.response : 'No response';
									$('#failedModal').find('.error_message').text(modal_error_message);
									$('#failedModal').modal({
										show: true
									});
								}


								// if(typeof data.data.response !== 'undefined' && data.data.response.toLowerCase().indexOf('error') === -1) {
								//
								// 	$('#successModal').find('.am_uuid').text(data.data.lead_uuid);
								// 	// $('#successModal').find('.cw_id').text(cw_id);
								// 	$('#successModal').modal({
								// 		show: true
								// 	});
								//
								// } else {
								//
								// 	$('#failedModal').find('.am_uuid').text(data.data.lead_uuid);
								// 	var modal_error_message = typeof data.data.response.length !== undefined && data.data.response.toLowerCase().indexOf('error') !== -1 ? data.data.response : 'No response';
								// 	$('#failedModal').find('.error_message').text(modal_error_message);
								// 	$('#failedModal').modal({
								// 		show: true
								// 	});
								// }


							} else {
								var targetUrl = '';

								if(typeof EXTERNAL_QUOTES_PAGE_URL !== 'undefined') {
									targetUrl = EXTERNAL_QUOTES_PAGE_URL.indexOf('?') >= 0 ? EXTERNAL_QUOTES_PAGE_URL + '&' : EXTERNAL_QUOTES_PAGE_URL + '?';
								}

								var urlParams = {
									uuid: data.data.lead_uuid,
									age: leadData.age,
									life_cover: leadData.life_cover,
									gender: leadData.gender,
									smoker: leadData.smoker,
									viewed_quotes: leadData.viewed_quotes,
									first_name: leadData.first_name,
									last_name: leadData.last_name,
								};

								if(leadData.viewed_quotes == 'no') {
									window.location = homeUrl + '/thankyou-advisor/?uuid=' + data.data.lead_uuid;
								} else {
									window.location = targetUrl += decodeURIComponent($.param(urlParams));
								}
								// updateQuotes(data.data.lead_uuid, leadData);
							}
						} else {
		                  console.error(data.error);
		                }

					},
					error: function(e) {
						console.log("there'\s an error submitting the lead", e);
						
						location.href = '/complete';

						// show the xsell modal
						// $('#failedModal .am_uuid').text(data.data.am_uuid);
						// $('#failedModal .am_uuid').text(data.data.cw_id);
						$('#failedModal').modal({
							show: true
						});

						if ($('#loading-logo').length > 0) {
							$('.formSubmit').show();
							$('#loading-logo').hide();
						}
						$('.formSubmit').removeClass('inprogress');
					}
				});

				setCookie('current', 'yes', 0.0347222222);
				localStorage.current = 'yes';
			}

			return false;
		// }
	}

	// update quotes
	function updateQuotes(uuid, additionalData) {
		$.ajax({
			url: apiUrl + 'policy/quotes/' + uuid,
			type: 'POST',
			data: {
				'apikey': apikey
			},
			success: function(data) {
				// console.log('*** UPDATE QUOTES ***');
				// console.log(additionalData);
				// console.log('*****');
				// heads or tails...
				// if (Math.floor((Math.random() * 10) + 1) % 2 === 0) {
				// 	window.location = homeUrl + '/thankyou-advisor/?uuid=' + uuid;
				// } else {
				var targetUrl = '';

				if(typeof EXTERNAL_QUOTES_PAGE_URL !== 'undefined') {
					targetUrl = EXTERNAL_QUOTES_PAGE_URL.indexOf('?') >= 0 ? EXTERNAL_QUOTES_PAGE_URL + '&' : EXTERNAL_QUOTES_PAGE_URL + '?';
				}

				var urlParams = {
					uuid: uuid,
					age: additionalData.age,
					life_cover: additionalData.life_cover,
					gender: additionalData.gender,
					smoker: additionalData.smoker,
					viewed_quotes: additionalData.viewed_quotes,
					first_name: additionalData.first_name,
					last_name: additionalData.last_name,
				};

				if(additionalData.viewed_quotes == 'no') {
					window.location = homeUrl + '/thankyou-advisor/?uuid=' + uuid;
				} else {
					window.location = targetUrl += decodeURIComponent($.param(urlParams));
				}
				// }
			},
			error: function(e) {
				console.log("there'\s an error", e);
			}
		});

	}

	$('.fillHidden').change(function() {
		var id = $(this).attr('id');
		var id_arr = id.split('-');
		id_arr.splice(0, 1);
		console.log('#amount-' + id_arr.join('-'))
		var hiddenfield = $('#amount-' + id_arr.join('-'));
		hiddenfield.val($(this).val());
	});


	// call back
	$('.cb-hero #bestTime').change(function() {
		checkcallhours();
	});

	$('.cb-hero #state').change(function() {
		checkcallhours()
	});

	$('.ref-add-form #bestTime').change(function() {
		checkcallhours()
	});

	$('.cb-hero #submit2').click(function() {
		if (checkcallhours()) {
			submitCB();
		} else {
			return false
		}
	});


	$('.callback-exit-intent #bestTime').change(function() {
      submitCB();
    });

	if ($('#get-a-cb').length > 0 || $('.ref-add-form').length > 0) {
		// debugger;
		var hour_default = ['10','12','15'];
		var weekday = ['MONDAY','TUESDAY','WEDNESDAY','THURSDAY','FRIDAY'];
        var today = current_date.getDay();

        if(today == weekday.length)
			today = 0;

        for (var y = 0; y < 3; y++) {
			var days = weekday[today];
     		for (var x = 0; x < date_options.length; x++) {
				$('#bestTime').append('<option value="' + days + '-' +hour_default[x] + '">' + days + ' - ' + date_options[x] + '</option>');
			}
			today++;

			if(today == weekday.length)
			today = 0;
        }
	}


	// if ($('#get-a-cb').length > 0) {
	// 	for (var x = 0; x < date_options.length - hours_difference; x++) {
	// 		$('#bestTime').append('<option value="' + hour_default + '">' + date_options[x] + '</option>');
	// 		hour_default++;
	// 	}
	// }

	function submitCB() {

		$('.formSubmit').addClass('inprogress');
		var uuid = $('#get-a-cb').attr('action').split('/request-callback/').slice(1, 2).join(''),
			uuid = uuid.replace('/', ''),
			submitURL = apiUrl + 'callback/request/' + uuid,
			submitCBData = {
				callbackTime: $('#bestTime').val(),
				'apikey': apikey,
				uuid
			};

		console.log(submitCBData, uuid)

		$.ajax({
			url: submitURL,
			type: 'POST',
			data: submitCBData,
			success: function(data) {
				console.log('success');
				$('.modal1').css('top','10px');
				$('.cb-alert').addClass('alert-visible');
				$('#submit-cb').removeClass('inprogress');
				$('#ouibounce-modal #get-a-cb, #ouibounce-modal .content').hide();
      			$('#ouibounce-modal .alert').show();
			},
			error: function(e) {
				console.log("there'\s an error", e);
			}
		});

	}

	function checkcallhours() {
		var cbdate = new Date();
		var cbday = cbdate.getDay();
		var thestate = $("#state").val();
		var btime = parseInt($('#bestTime').val());
		var callhoursresult = true;
		$('.errorhours').fadeOut();
		$('.formSubmit').removeClass('inprogress');

		if (thestate == 'nsw' | thestate == 'vic' | thestate == 'qld') {
			if (btime < 9) {
				$('.errorhours').fadeIn();
				callhoursresult = false;
			} else {
				if (cbday === 6) {
					if (btime > 16) {
						$('.errorhours').fadeIn();
						callhoursresult = false;
					}
				}
			}
		} else if (thestate == 'sa') {
			if (btime < 8) {
				$('.errorhours').fadeIn();
				callhoursresult = false;
			} else {
				if (cbday === 6) {
					if (btime > 16) {
						$('.errorhours').fadeIn();
						callhoursresult = false;
					}
				}
			}
		} else if (thestate == 'nt') {
			if (btime < 7 | btime > 18) {
				$('.errorhours').fadeIn();
				callhoursresult = false;
			} else {
				if (cbday === 6) {
					if (btime > 15 | btime < 8) {
						$('.errorhours').fadeIn();
						callhoursresult = false;
					}
				}
			}
		} else if (thestate == 'wa') {
			if (btime < 6 | btime > 16) {
				$('.errorhours').fadeIn();
				callhoursresult = false
			} else {
				if (cbday === 6) {
					if (btime > 14) {
						$('.errorhours').fadeIn();
						callhoursresult = false
					}
				}
			}
		}

		return callhoursresult;
	}

	$('.cb-panel-close').click(function(e) {
		e.preventDefault();
		$('.cb-alert').removeClass('alert-visible');
	});

	$('*[data-toggle="tooltip"]').tooltip();

	$(window).resize(function() {
		$('.tooltip').remove();
	});

	// navigation
	$('.toggle-menu').on('click', function(e) {
		e.preventDefault();

		if ($(this).hasClass('open-nav')) {
			$(this).removeClass('open-nav');
			$('nav.mega-menu > ul').removeClass('open-nav');
		} else {
			$(this).addClass('open-nav');
			$('nav.mega-menu > ul').addClass('open-nav');
		}

	});

	// social
	$(".social_popup").on("click", function(t) {
		var n = $(this).attr("data-href");
		window.open(n, "", "screenX=100,screenY=100,height=360,width=730");
		t.preventDefault();
		t.stopPropagation();
	});



	// modal hide
	$('#successModal').on('hidden.bs.modal', function(e) {
		// do something...
		if ($('#loading-logo').length > 0) {
			$('.formSubmit').show();
			$('#loading-logo').hide();
		}
	})


	$('#failedModal').on('hidden.bs.modal', function(e) {
		// do something...
		if ($('#loading-logo').length > 0) {
			$('.formSubmit').show();
			$('#loading-logo').hide();
		}
		$('.formSubmit').removeClass('inprogress');

		$('#leadformDetails input, #leadformDetails textarea').each(function() {
			$(this).val('')
		});

	});

	// submit hidden form
	if ($('body').hasClass('page-template-tpl-basic-template')) {

		var leadDetailsString = 'Hi, your client ' + client_name + ' would like to apply based on your quote. Please follow up at your earliest convenience. ';

		$('.hiddenSubmitForm textarea').val(leadDetailsString);
		$('.hiddenSubmitForm input[type=email]').val(owner_email);
		$('.hiddenSubmitForm input[type=text]').val(client_name);

		if(client_name !== '' && owner_email !== '')
			$('.hiddenSubmitForm form').submit();

	}

	// get param values
	function parse_query_string(query) {
		var query = query.indexOf('&') == 0 ? query.substring(1) : query;
		var vars = query.split("&");
		var query_string = {};
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split("=");
			// If first entry with this name
			if (typeof query_string[pair[0]] === "undefined") {
				query_string[pair[0]] = decodeURIComponent(pair[1]);
				// If second entry with this name
			} else if (typeof query_string[pair[0]] === "string") {
				var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
				query_string[pair[0]] = arr;
				// If third or later entry with this name
			} else {
				query_string[pair[0]].push(decodeURIComponent(pair[1]));
			}
		}
		return query_string;
	}

	// utm source check
	// function source_check(utm, param) {

	// 	var utms = param !== '' ? parse_query_string(param) : (window.location.search.length > 0 ? parse_query_string(window.location.search.substring(1)) : '');
	// 	var utm_source = checkCookie('Source') ? getCookie('Source') : decodeURIComponent(document.referrer);
	// 	var utm_medium = checkCookie('Medium') ? getCookie('Medium') : (utm_source.indexOf('gclid=') !== -1 || document.location.search.indexOf('gclid=') !== -1 ? 'cpc' : 'organic');

	// 	if(typeof utms.utm_source !== 'undefined') {

	// 		utm_source = utms.utm_source;
	// 		setCookie('Source', utm_source, 7);

	// 	} else if(!checkCookie('Source')) {

	// 		var getSource = setSourceMedium(utm_source);

	// 		utm_source = getSource.utm_source;

	// 		setCookie('Source', utm_source, 7);
	// 	}

	// 	if(typeof utms.utm_medium !== 'undefined') {

	// 		utm_medium = utms.utm_medium;
	// 		setCookie('Medium', utm_medium, 7);

	// 	} else if(!checkCookie('Medium')) {

	// 		var getMedium = setSourceMedium(utm_source);

	// 		utm_medium = getMedium.utm_medium;
	// 		setCookie('Medium', utm_medium, 7);

	// 	}

	// 	if(utm == 'Medium')
	// 		return utm_medium;
	// 	else
	// 		return utm_source;

	// }

	// function setSourceMedium(utm_source) {

	// 	var result = {utm_source: 'other', utm_medium: 'organic'};
	// 	var locationLower = document.location.search.toLowerCase();
	
	// 	if(utm_source.indexOf('facebook.') !== -1 || utm_source.indexOf('messenger.') !== -1 || locationLower.indexOf('fbclid') !== -1 || document.location.search.indexOf('fb.') !== -1) {
	// 		result.utm_source = 'facebook';
	// 	} else if(utm_source.indexOf('google.') !== -1 || utm_source.indexOf('gclid=') !== -1 || locationLower.indexOf('gclid=') !== -1) {
	// 		result.utm_source = 'google';
	// 	} else if(utm_source.indexOf('yahoo.') !== -1) {
	// 		result.utm_source = 'yahoo';
	// 	} else if(utm_source.indexOf('duckduckgo') !== -1) {
	// 		result.utm_source = 'duckduckgo';
	// 	} else if(utm_source.indexOf('bing') !== -1 || utm_source.indexOf('msclkid') !== -1 || locationLower.indexOf('msclkid') !== -1) {
	// 		result.utm_source = 'bing';
	// 	} else if(utm_source.indexOf('ob_click_id') !== -1 || locationLower.indexOf('ob_click_id') !== -1) {
	// 		result.utm_source = 'outbrain';
	// 	} else if(utm_source.indexOf('click-id') !== -1 || locationLower.indexOf('click-id') !== -1) {
	// 		result.utm_source = 'taboola';
	// 	} else if(utm_source.indexOf('twitter.') !== -1 || utm_source.indexOf('t.co') !== -1) {
	// 		result.utm_source = 'twitter';
	// 	} else if(
	// 		utm_source.indexOf('healthinsurancecomparison.') !== -1 ||
	// 		utm_source.indexOf('alternativemedia.') !== -1 ||
	// 		utm_source.indexOf('electricityandgas.') !== -1 ||
	// 		utm_source.indexOf('homeloansaustralia.') !== -1 ||
	// 		utm_source.indexOf('ratecomparison.') !== -1 ||
	// 		utm_source.indexOf('hearingaidcomparison.') !== -1 ||
	// 		utm_source.indexOf('mybroadbandcomparison.') !== -1
	// 	) {
	// 		result.utm_source = 'self-referral';
	// 	} else if(utm_source.indexOf('lifeinsurancecomparison.') !== -1 || utm_source == '') {
	// 		result.utm_source = 'direct';
	// 	} else {
	// 		result.utm_source = 'other';
	// 	}
	
	// 	if(result.utm_source === 'facebook' || result.utm_source === 'twitter')
	// 		result.utm_medium = 'social';
	// 	else if(utm_source.indexOf('msclkid') !== -1 || locationLower.indexOf('msclkid') !== -1 || utm_source.indexOf('gclid=') !== -1 || locationLower.indexOf('gclid=') !== -1)
	// 		result.utm_medium = 'cpc';
	// 	else if(result.utm_source === 'taboola' || result.utm_source === 'outbrain')
	// 		result.utm_medium = 'native';
	
	// 	return result;
	
	// }

});


// calc modal script
$(window).bind("load", function() {

	// run script only if these elements exists
	if($('.calc-insert').length > 0 && $('.calc-btn').length > 0) {

		$('input[name=life_cover]').attr('max',5000000).rangeslider('update', true);

		var estLifeCover = 0, estTraumaCover = 0, estIpCover = 0, estTpdCover = 0, est_salary = 0;

		// add css file for calculator font
		var avenirCss = '<link rel="stylesheet" href="'+ tempUrl +'/assets/css/avenir.min.css" />';
		$('head').append(avenirCss);

		// append hidden field on form
		var hiddenFields = '<input type="hidden" name="used_cover_calculator" id="used_cover_calculator" value="no">';
		$('.leadform form').append(hiddenFields);

		// open modal on button clicked
		$('.calc-btn').click(function(e){
			e.preventDefault();
			$('.calc-modal-container').addClass('active fadeIn');
			$('body').addClass('calcModalOpen');
			ga('send', 'event', 'navigateModal', 'click', 'Started Calculator');
		});

		// remove default animation class
		$('.calc-modal-container').on('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
			$(this).removeClass('fadeIn fadeOut');
		});

		// close modal
		$('.calc-modal-close, .calc-modal .modal-submit').click(function(e){
			e.preventDefault();
			var usedCoverCalc;
			if($(this).hasClass('modal-submit')) {

				usedCoverCalc = true;

				ga('send', 'event', 'navigateModal', 'click', 'Finished Calculator');

				$('.range-output2').text('$' + addCommas(estLifeCover));
				$('input[name=life_cover]').val(estLifeCover).rangeslider('update', true);

				// set values for hidden fields
				$('#tpd_sum_insured_hidden').val(estTpdCover);
				$('#trauma_sum_insured_hidden').val(estTraumaCover);

				$('#salary_hidden').val(est_salary); // added est_salary val
			}
			closeCalcModal(usedCoverCalc);
		});

		$('.calc-modal-container').mouseup(function(e)
		{
		    var container = $(".calc-modal");
		    if (!container.is(e.target) && container.has(e.target).length === 0)
		    {
				closeCalcModal();
		    }
		});

		function closeCalcModal(usedCoverCalc) {
			ga('send', 'event', 'navigateModal', 'click', 'Closed modal');

			$('.calc-modal-container').addClass('fadeOut');
			$('body').removeClass('calcModalOpen');
			$('.calc-modal-container').removeClass('visible-next hidden-last visible-last');
			$('.modal-step, .calc-modal-col li').removeClass('active fadeIn');
			$('.calc-modal-col ol').removeAttr('class');

			if(typeof(usedCoverCalc) !== 'undefined') {
				proceed_next_1 = true, proceed_next_2 = true;
				$('.leadform form').submit();
			}

			$('.calc-modal-container').removeClass('active fadeOut');

			setTimeout(function(){
				// set default
				$('.calc-modal-col li').eq(0).addClass('active currentClass');
				$('#modal-step-1').addClass('active');
			}, 500);
		}

		// ***** navigate to the steps
		$('.modal-next, .modal-back').click(function(e){

			var activeStep = $('.modal-step.active').attr('id');
				currentStep = parseInt(activeStep.split('modal-step-')[1]),
				moveForward = true;

			if($(this).hasClass('modal-back')) {
				moveForward = false;
			}

			// if(validateFormFields('#' + activeStep)) // step validation
			calcModalSteps(currentStep, moveForward);

		});

		function calcModalSteps(currentStep, moveForward){

			$('html, body, .calc-modal-container').animate({
				'scrollTop': 0
			}, 300, 'swing');

			var stepName = '#modal-step-',
				maxStep = $('.modal-step').length,
				goNext = !moveForward ? currentStep - 1 : currentStep + 1,
				stepHeadline = goNext == maxStep ? 'Your Results' : 'How much cover do I need?';

			$('.col-modal-main h1').text(stepHeadline);

			if(!moveForward) {
				ga('send', 'event', 'navigateModal', 'click', 'Back button clicked');
			} else {
				ga('send', 'event', 'navigateModal', 'click', 'Next button clicked');
			}

			$('.calc-modal-container').removeClass('visible-next hidden-last visible-last');
			$('.modal-step').removeClass('active fadeIn');
			$('.calc-modal-col ol').removeClass('active-2 active-3 active-4');
			$('.calc-modal-col li, .graph2').removeClass('active currentStep');

			if(goNext > 1 && goNext !== maxStep) {
				$('.calc-modal-container').addClass('visible-next');
			}

			if(goNext == maxStep) {
				$('.calc-modal-container').addClass('hidden-last visible-last');
				calcGetResults()
			}

			if(goNext > 0) {
				$(stepName + goNext).addClass('active fadeIn');
				for(var x = 0; x < goNext; x++) {
					var currentClass = '';
					if(x == goNext - 1) {
						currentClass = ' currentStep';
					}
					$('.calc-modal-col li').eq(x).addClass('active' + currentClass);
				}

			}

			$('.calc-modal-col ol').addClass('active-' + goNext);

		}

		function calcGetResults() {

			// Outstanding Debts fields
			var outstandingDebts = [];
			$('#modal-step-1 input').each(function(){
				outstandingDebts.push(parseInt(clearMoneyFormat(getInputValue($(this)))));
			});

			// outstandingDebts[0] -> Mortgages (Home + Investment)
			// outstandingDebts[1] -> Personal loans
			// outstandingDebts[2] -> Credit card debt
			// outstandingDebts[3] -> Funeral Costs (default)

			// ===== Income & Assets ===== //
			$('#modal-step-2 input').each(function(){
				outstandingDebts.push(parseInt(clearMoneyFormat(getInputValue($(this)))));
			});
			// outstandingDebts[4] -> income
			est_salary = outstandingDebts[4];
			// outstandingDebts[5] -> annual expenses
			// outstandingDebts[6] -> investment
			// outstandingDebts[7] -> total savings

			// Existing Cover
			var existingCover  = [];
			$('#modal-step-3 input').each(function(){
				existingCover.push(parseInt(clearMoneyFormat(getInputValue($(this)))));
			});

			// existingCover[0] -> Existing life cover
			// existingCover[1] -> Existing TPD cover
			// existingCover[2] -> Existing IP cover
			// existingCover[3] -> Existing trauma cover

			// Excel variables
			var expenses = outstandingDebts[0] + outstandingDebts[1] + outstandingDebts[2] + outstandingDebts[3], // Debt/Death Expenses
				assets = outstandingDebts[6] + outstandingDebts[7]; // Assets

			// lifeCoverResult
			var age = parseInt($('input[name=age]').val());

				estLifeCover = outstandingDebts[4]*(1- Math.pow(((1+0.03)/(1+0.06)), (65-age)))*(1.06)/(0.06-0.03)+(expenses-assets);
				estLifeCover = Math.round((estLifeCover > 5000000 ? 5000000 : estLifeCover) / 100000) * 100000;

				$('#est-life-cover').text('$ ' + addCommas(Math.round(estLifeCover)));

			// tpdCoverResult
			// Math.round(expenses-assets + outstandingDebts[4]* Math.pow((1+(0.1-0.03)), (65-age))), -> old formula
			estTpdCover = estLifeCover - outstandingDebts[3];
				$('#est-tpd-cover').text('$ ' + addCommas(estTpdCover));

			// ipCoverResult
			estIpCover = Math.round(outstandingDebts[4]*0.75/12);
			estIpCover = estIpCover > 30000 ? 30000 : estIpCover;
				$('#est-ip-cover').text('$ ' + addCommas(estIpCover));

			// traumaCoverResult
			estTraumaCover = (outstandingDebts[0] + outstandingDebts[1] + outstandingDebts[2]) + outstandingDebts[4];
			estTraumaCover = Math.round((estTraumaCover > 3000000 ? 3000000 : estTraumaCover) / 10000) * 10000;

				$('#est-trauma-cover').text('$ ' + addCommas(estTraumaCover));


			// Graph results
			setTimeout(function(){
				$('.graph2').css({'height': '100%'});

				$('.graph2').each(function(i){
					var elem = $(this);
					setTimeout(function(){
						elem.addClass('active');
					}, 500 + (200 * i));
				});
			}, 1000);

			ga('send', 'event', 'navigateModal', 'click', 'Calculate results');

			// update hidden field value
			$('#used_cover_calculator').val('yes');

		}

		function clearMoneyFormat(value) {
			return value.replace(/[\D\s\._\-]+/g, "")
		}

		function getInputValue(element) {
			return element.val() == '' ? element.attr('placeholder') : element.val();
		}

		function getArrSum(arr) {
			var total = 0;
			for(var x = 0;x < arr.length;x++)
				total += arr[x];
			return total;
		}

		// format money without '$ '
		$('.noSign').on('keyup',function(){
			$(this).val(addCommas(clearMoneyFormat($(this).val())));
		});

		// custom tooltip
		$('.label-help').hover(function(){
			var tipContent = $(this).attr('data-content');
			if(typeof(tipContent) !== 'undefined') {
				$(this).addClass('showTip').children('i').html(tipContent);
			}
		}, function(){
			$(this).removeClass('showTip');
		});


		// focus event
		var fieldDefaults = [];
		$('.modal-step input').each(function(i){
			var index = i;
			fieldDefaults.push($(this).attr('placeholder'));

			$(this).on('focus', function(){
				$(this).attr('placeholder','');
			}).on('blur',function(){
				$(this).attr('placeholder',fieldDefaults[index]);
			});
		});

	}
});

// Occupation Autocomplete
var arr = [];

$.getJSON("//assets.lifeinsurancecomparison.com.au/assets/convertcsv-occupation.json", function(data) {
	$.each(data, function(name, value) {
		arr.push(value);
	});
	enableAutocomplete()
});

function enableAutocomplete() {
	$('.occAutocomplete').autoComplete({
		minChars: 1,
		source: function(term, suggest) {
			term = term.toLowerCase();
			var choices = arr;
			var matches = [];
			for (var i = 0; i < choices.length; i++) {
				if (~choices[i].name.toLowerCase().indexOf(term))
					matches.push(choices[i].name);
				if (matches.length > 4) {
					i = choices.length;
				}
			}
			suggest(matches);
		},
		onSelect: function(e, term, item) {
			term = e;
			for (var i = 0; i < arr.length; i++) {
				if (~arr[i].name.indexOf(term)) {
					$('#occupationID').val(arr[i].id);
				}
			}
			$('.autocomplete-suggestions').hide();
		},
		cache: false
	});
}

$('.occAutocomplete').on('keyup keypress', function(e) {
	var keyCode = e.keyCode || e.which;
	if (keyCode === 13) {
		$('.autocomplete-suggestions').hide();
		occAutocomplete($(this))
		$(this).blur()
		e.preventDefault();
		return false;
	}
});

$('.occAutocomplete').on('blur', function(e) {
	occAutocomplete($(this))
})

$('.occAutocomplete').on('focus', function(e) {
	$('.occupationErrorTip').remove();
})

function occAutocomplete(elem) {
	var term = elem.val().toLowerCase();
	occExist = false;
	for (var i = 0; i < arr.length; i++) {
		if (arr[i].name.indexOf(term)) {
			if (arr[i].name.toLowerCase() === term) {
				elem.val(arr[i].name);
				$('#occupationID').val(arr[i].id),
					occExist = true,
					i = arr.length;
			}
		}
	}
	if (occExist === false) {
		if (elem.val() !== '') {
			var a = elem.offset();
			a.left += 0, a.top += elem.outerHeight() - 15;
			var tp = $('<div class="tooltip bottom in validity-tooltip occupationErrorTip"><div class="tooltip-arrow"></div><div class="tooltip-inner ">Please select the closest occupation from the list.</div></div>').mouseover(function() {
				$(this).fadeOut()
			}).css(a).hide().appendTo("body").fadeIn();
			elem.addClass('occError');
		}
	} else {
		if ($('.occupationErrorTip').length > -1)
			$('.occupationErrorTip').remove();
		elem.removeClass('occError');
	}
}
